import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { TextField } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { emailInputTestId } from "./constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const EmailInput = ({ control, required }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    return (_jsx(Controller, { name: "email", control: control, defaultValue: "", render: ({ field, fieldState: { error } }) => (_jsx(TextField, Object.assign({ type: "email", testId: emailInputTestId }, field, { hasNecessityIndicator: required, isFullWidth: true, label: t("contact.form.email"), placeholder: t("contact.form.email_placeholder"), error: error === null || error === void 0 ? void 0 : error.message, isDisabled: isPreviewMode }))) }));
};
